import { render } from "./Slogan4.vue?vue&type=template&id=d38bba8c&scoped=true&lang=true"
import script from "./Slogan4.vue?vue&type=script&lang=js"
export * from "./Slogan4.vue?vue&type=script&lang=js"

import "./Slogan4.vue?vue&type=style&index=0&id=d38bba8c&lang=css&scoped=true"

import exportComponent from "C:\\Users\\dev2\\Documents\\dev\\sitio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d38bba8c"]])

export default __exports__